import { useQuery } from '@tanstack/react-query';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { isValidObjectId } from '@/utils';

export const getPageReport: aiReportTypes.GetReport = ({ reportId }) => {
  return axios.get(`/page-reports/${reportId}`);
};

type QueryFnType = typeof getPageReport;

type UseGetPageReportOptions = {
  reportId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPageReport = ({ reportId, config = {} }: UseGetPageReportOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['page-report', reportId],
    // Never request /page-reports/<anything>: "types", "prompt", " " hit other endpoints (DEV-3961).
    enabled: isValidObjectId(reportId),
    queryFn: () => getPageReport({ reportId }),
    refetchInterval: (data) => {
      const status = data?.report?.status;
      return status === 'queued' || status === 'running' ? 4000 : false;
    },
  });
};
